import { httpGet, httpPost, httpPut } from '../http';

export default () => {
    const snakeToCamel = (res) => res.map(({
        bank_account_id: bankAccountId,
        company_name: companyName,
        account_number: accountNumber,
        branch_code: branchCode,
        branch_name: branchName,
        phrase,
        website,
        bank,
    }) => ({
        bankAccountId,
        companyName,
        accountNumber,
        branchCode,
        branchName,
        phrase,
        website,
        bank,
    }));

    const camelToSnake = (data) => ({
        company_name: data.companyName,
        account_number: data.accountNumber,
        branch_code: data.branchCode,
        branch_name: data.branchName,
        phrase: data.phrase,
        website: data.website,
        bank_id: data.bankId,
    });

    const snakeToCamelActivity = (res) => ({
        startTime: res.start_time,
        endTime: res.end_time,
        timeEnabled: res.working_time_enabled,
        limitEnabled: res.limit_enabled,
        limitStartDate: res.limit_start_date,
        days: res.days,
        avRange: res.av_range.map((av) => ({
            startDay: av.start_day,
            endDay: av.end_day,
            minTransactions: av.min_trx,
            maxTransactions: av.max_trx,
        })),
        active: res.active,
        startDateDiff: res.start_date_diff,
    });

    const fetchBankAccounts = async () => {
        const response = await httpGet(
            'bank-accounts/',
        );

        return snakeToCamel(response);
    };

    const postBankAccount = async (data) => {
        const response = await httpPost(
            'bank-accounts/',
            {},
            camelToSnake(data),
        );

        return snakeToCamel([response])[0];
    };

    const editBankAccount = async (data) => {
        const response = await httpPut(
            `bank-accounts/${data.bankAccountId}`,
            {},
            camelToSnake(data),
        );

        return snakeToCamel([response])[0];
    };

    const fetchConnectedBanks = async (merchantId, groupType) => {
        const response = await httpGet(
            `bank-accounts/connect/${merchantId}`,
            {
                group_type: groupType,
            },
        );

        return response;
    };

    const camelToSnakeConnect = (data) => ({
        bank_account_id: data.bankAccountId,
        merchant_id: data.merchantId,
        type: data.type,
    });

    const connect = async (data) => {
        await httpPost(
            'bank-accounts/connect/',
            {},
            camelToSnakeConnect(data),
        );
    };

    const disconnect = async (data) => {
        await httpPost(
            'bank-accounts/disconnect/',
            {},
            camelToSnakeConnect(data),
        );
    };

    const changeBankAccountAvailability = async (bankAccountId, data) => {
        await httpPost(
            `bank-activity/${bankAccountId}/`,
            {},
            data,
        );
    };

    const getBankAccountActivity = async (bankAccountId) => {
        const response = await httpGet(
            `bank-activity/${bankAccountId}/`,
        );

        if ('start_time' in response) {
            return snakeToCamelActivity(response);
        }

        return undefined;
    };

    return {
        connect,
        disconnect,
        editBankAccount,
        fetchBankAccounts,
        fetchConnectedBanks,
        postBankAccount,
        changeBankAccountAvailability,
        getBankAccountActivity,
    };
};
